import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  violations: null,
  success: false,
  error: false
};

const EventSongAddSlice = createSlice({
  name: "EventSongAdd",
  initialState,
  reducers: {
    eventSongAddSuccess(state, action) {
      state.success = true;
    },
    eventSongAddError(state, action) {
      state.violations = action.payload;
      state.error = true;
    },
    eventSongAddReset(state) {
      state.success = false;
      state.violations = null
      state.error = false
    },
  },
});

export const {
  eventSongAddSuccess,
  eventSongAddError,
  eventSongAddReset,
} = EventSongAddSlice.actions

export default EventSongAddSlice.reducer;
